"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCustomPageActionsApi = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _sliReactMetrics = require("@cvent/sli-react-metrics");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useCustomPageActionsApi = exports.useCustomPageActionsApi = function useCustomPageActionsApi() {
  var measureActionsAttributesRef = (0, _react.useRef)({});
  var _usePageActions = (0, _sliReactMetrics.usePageActions)(),
    startAction = _usePageActions.startAction,
    endAction = _usePageActions.endAction,
    getBaseProps = _usePageActions.getBaseProps;
  var startRecordingStartWorkflow = (0, _react.useCallback)(function (props, options, callback) {
    // grab the action status and pass it as options so reporters can use it as they please
    var actionStatus = 'active';
    // Measure action via the pageActions API
    var data = _objectSpread({}, props);
    // Grab the destinations from the definition so the rudderstack reporter configures
    // the integrations accordingly
    var destinations = ['datadog'];
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: "studio recording : ".concat(data.recordingId, " start workflow")
    }, destinations && {
      destinations: destinations
    });
    var version = '';
    // This is passed as a property so via a transformation we use the downstreamName instead
    var downstreamName = "recording : ".concat(data.recordingId, " start workflow");
    measureActionsAttributesRef.current['studio recording start workflow'] = data;
    // Check if the definition contains metadata
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    startAction(action, _objectSpread(_objectSpread({}, data), {}, {
      version: version,
      downstreamName: downstreamName
    }), callback, _objectSpread(_objectSpread({}, options), {}, {
      status: actionStatus,
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [startAction]);
  var endRecordingStartWorkflow = (0, _react.useCallback)(function (props, options) {
    // grab the action status and pass it as options so reporters can use it as they please
    var actionStatus = 'active';
    var baseProps = getBaseProps();
    // Record action via the pageActions API
    var data = _objectSpread(_objectSpread({}, props), baseProps);
    var version = '';
    // This is passed as a property so via a transformation we use the downstreamName instead
    var downstreamName = "recording : ".concat(data.recordingId, " start workflow");
    endAction("studio recording : ".concat(data.recordingId, " start workflow"), _objectSpread(_objectSpread({}, data), {}, {
      version: version,
      downstreamName: downstreamName
    }), false, _objectSpread(_objectSpread({}, options), {}, {
      status: actionStatus
    }));
  }, [endAction]);
  var startRecordingStopWorkflow = (0, _react.useCallback)(function (props, options, callback) {
    // grab the action status and pass it as options so reporters can use it as they please
    var actionStatus = 'active';
    // Measure action via the pageActions API
    var data = _objectSpread({}, props);
    // Grab the destinations from the definition so the rudderstack reporter configures
    // the integrations accordingly
    var destinations = ['datadog'];
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: "studio recording : ".concat(data.recordingId, " stop workflow")
    }, destinations && {
      destinations: destinations
    });
    var version = '';
    // This is passed as a property so via a transformation we use the downstreamName instead
    var downstreamName = "recording : ".concat(data.recordingId, " stop workflow");
    measureActionsAttributesRef.current['studio recording stop workflow'] = data;
    // Check if the definition contains metadata
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    startAction(action, _objectSpread(_objectSpread({}, data), {}, {
      version: version,
      downstreamName: downstreamName
    }), callback, _objectSpread(_objectSpread({}, options), {}, {
      status: actionStatus,
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [startAction]);
  var endRecordingStopWorkflow = (0, _react.useCallback)(function (props, options) {
    // grab the action status and pass it as options so reporters can use it as they please
    var actionStatus = 'active';
    var baseProps = getBaseProps();
    // Record action via the pageActions API
    var data = _objectSpread(_objectSpread({}, props), baseProps);
    var version = '';
    // This is passed as a property so via a transformation we use the downstreamName instead
    var downstreamName = "recording : ".concat(data.recordingId, " stop workflow");
    endAction("studio recording : ".concat(data.recordingId, " stop workflow"), _objectSpread(_objectSpread({}, data), {}, {
      version: version,
      downstreamName: downstreamName
    }), false, _objectSpread(_objectSpread({}, options), {}, {
      status: actionStatus
    }));
  }, [endAction]);
  var startStreamStartLifecycle = (0, _react.useCallback)(function (props, options, callback) {
    // grab the action status and pass it as options so reporters can use it as they please
    var actionStatus = 'active';
    // Measure action via the pageActions API
    var data = _objectSpread({}, props);
    // Grab the destinations from the definition so the rudderstack reporter configures
    // the integrations accordingly
    var destinations = ['datadog'];
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: "studio stream : ".concat(data.streamId, " start lifecycle")
    }, destinations && {
      destinations: destinations
    });
    var version = '';
    // This is passed as a property so via a transformation we use the streamName instead
    var streamName = "stream : ".concat(data.streamId, " start lifecycle");
    measureActionsAttributesRef.current['studio stream start lifecycle'] = data;
    // Check if the definition contains metadata
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    startAction(action, _objectSpread(_objectSpread({}, data), {}, {
      version: version,
      streamName: streamName
    }), callback, _objectSpread(_objectSpread({}, options), {}, {
      status: actionStatus,
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [startAction]);
  var endStreamStartLifecycle = (0, _react.useCallback)(function (props, options) {
    // grab the action status and pass it as options so reporters can use it as they please
    var actionStatus = 'active';
    var baseProps = getBaseProps();
    // Record action via the pageActions API
    var data = _objectSpread(_objectSpread({}, props), baseProps);
    var version = '';
    // This is passed as a property so via a transformation we use the streamName instead
    var streamName = "stream : ".concat(data.streamId, " start lifecycle");
    endAction("studio stream : ".concat(data.streamId, " start lifecycle"), _objectSpread(_objectSpread({}, data), {}, {
      version: version,
      streamName: streamName
    }), false, _objectSpread(_objectSpread({}, options), {}, {
      status: actionStatus
    }));
  }, [endAction]);
  var startStreamStopLifecycle = (0, _react.useCallback)(function (props, options, callback) {
    // grab the action status and pass it as options so reporters can use it as they please
    var actionStatus = 'active';
    // Measure action via the pageActions API
    var data = _objectSpread({}, props);
    // Grab the destinations from the definition so the rudderstack reporter configures
    // the integrations accordingly
    var destinations = ['datadog'];
    // RudderStack unique action name for the workspace
    var action = _objectSpread({
      id: "studio stream : ".concat(data.streamId, " stop lifecycle")
    }, destinations && {
      destinations: destinations
    });
    var version = '';
    // This is passed as a property so via a transformation we use the streamName instead
    var streamName = "stream : ".concat(data.streamId, " stop lifecycle");
    measureActionsAttributesRef.current['studio stream stop lifecycle'] = data;
    // Check if the definition contains metadata
    var metadata = JSON.parse('{}');
    var hasMetadata = Object.keys(metadata).length > 0;
    startAction(action, _objectSpread(_objectSpread({}, data), {}, {
      version: version,
      streamName: streamName
    }), callback, _objectSpread(_objectSpread({}, options), {}, {
      status: actionStatus,
      metadata: hasMetadata ? metadata : undefined
    }));
  }, [startAction]);
  var endStreamStopLifecycle = (0, _react.useCallback)(function (props, options) {
    // grab the action status and pass it as options so reporters can use it as they please
    var actionStatus = 'active';
    var baseProps = getBaseProps();
    // Record action via the pageActions API
    var data = _objectSpread(_objectSpread({}, props), baseProps);
    var version = '';
    // This is passed as a property so via a transformation we use the streamName instead
    var streamName = "stream : ".concat(data.streamId, " stop lifecycle");
    endAction("studio stream : ".concat(data.streamId, " stop lifecycle"), _objectSpread(_objectSpread({}, data), {}, {
      version: version,
      streamName: streamName
    }), false, _objectSpread(_objectSpread({}, options), {}, {
      status: actionStatus
    }));
  }, [endAction]);
  return {
    startRecordingStartWorkflow: startRecordingStartWorkflow,
    endRecordingStartWorkflow: endRecordingStartWorkflow,
    startRecordingStopWorkflow: startRecordingStopWorkflow,
    endRecordingStopWorkflow: endRecordingStopWorkflow,
    startStreamStartLifecycle: startStreamStartLifecycle,
    endStreamStartLifecycle: endStreamStartLifecycle,
    startStreamStopLifecycle: startStreamStopLifecycle,
    endStreamStopLifecycle: endStreamStopLifecycle
  };
};